import moment from 'moment-timezone';

const BACK_IN_STOCK_TAG_ID = '6842f6f631633b0a9eed9345';
const TAG_DAYS = 14;

const buildPutInStockPayload = (productId, variantId) => {
  const startDate = moment();
  const endDate = startDate.clone().add(TAG_DAYS, 'days');

  return {
    productId: productId,
    variantId: variantId,
    stockStatus: 'IN_STOCK',
    enabled: true,
    tag: BACK_IN_STOCK_TAG_ID,
    tagStartDate: startDate.format('YYYY-MM-DD') + 'T00:00:00.000Z',
    tagEndDate: endDate.format('YYYY-MM-DD') + 'T23:59:59.000Z'
  };
};

export { buildPutInStockPayload };
